import { underScoreSpaces } from 'pages/Allocation/allocations/utilities/util';
import {
  SHEET_TITLES_CONSTANTS as EQUITY_ALLOCATION_SHEET_TITLES_CONSTANTS
} from 'pages/ValuationsAllocation/common/constants/equityAllocation';
import { getColumnLetter } from 'utilities/alphabet-utilities';
import { GenerateWeightedValuePerShareExpressionParams } from './types';
import generateEquityAllocationKey from '../../../../../EquityAllocation/config/util/generate-equity-allocation-key';

const {
  EQUITY_ALLOCATION_SCENARIO_WEIGHTING_PROBABILITY_ROW,
  FIRST_ALLOCATION_SCENARIOS_COLUMN_NUMBER,
  getAdjustedColumnNumber,
} = EQUITY_ALLOCATION_SHEET_TITLES_CONSTANTS;

const generateWeightedValuePerShareExpression = (params: GenerateWeightedValuePerShareExpressionParams) => {
  const { allocationScenarios, isUniformCurrency, security: securityName, relatedEntityId } = params;

  const firstScenarioColumn = getAdjustedColumnNumber({
    colNumber: FIRST_ALLOCATION_SCENARIOS_COLUMN_NUMBER,
    includeAllColumns: true,
    isUniformCurrency: !isUniformCurrency,
  });

  const scenariosColumnsNumbers = Array.from(
    { length: allocationScenarios.length },
    (_, index) => index + firstScenarioColumn
  );

  const scenariosColumnsLetters = scenariosColumnsNumbers.map(colNumber => getColumnLetter(colNumber));

  const relatedEntityIdKey = generateEquityAllocationKey(relatedEntityId);

  // Scenario Weighting Probability
  const scenarioWeightingProbabilityCells = scenariosColumnsLetters
    .map(letter => `${relatedEntityIdKey}.${letter}${EQUITY_ALLOCATION_SCENARIO_WEIGHTING_PROBABILITY_ROW}`)
    .join(',');

  // Present Value Per Share
  const presentValuePerShareCells = scenariosColumnsLetters
    .map(letter => {
      const securityRef = `${underScoreSpaces(securityName)}_${letter}`;
      return `${relatedEntityIdKey}.${securityRef}`;
    })
    .join(',');

  return { scenarioWeightingProbabilityCells, presentValuePerShareCells };
};

export default generateWeightedValuePerShareExpression;
